<template>
    <div>
        <div class="score-wrapper pt-5 mb-5">
            <h2 class="order-form-name mb-3 pb-3">My Scores</h2>
            <div class="score-instructions mb-3">
                <p class="f-16">Entries are judged against a standard of excellence on their own merit and do not
                    compete against each other.</p>
                <p class="f-16">Please rate each entry on a scale of 1 to 7 in the following criteria.</p>
                <ul class="pl-3">
                    <li v-for="(meaning, index) in voteMeaningArray">
                        {{ voteMeaningArray.length - index }} - {{ meaning }}
                    </li>
                </ul>
            </div>

          <div class="score-wrapper pt-3">
            <fieldset class="fieldset-stars-wrapper mt-3 mb-3 d-block d-xl-flex align-items-start justify-content-between">
              <div class="meaning-wrapper">
                <div class="content-label mb-2"><strong>Content:</strong> To what extent does the entry contain
                  informative, entertaining or motivational material consistent with the entry’s purposes?
                </div>
                <div class="font-italic pl-4 vote-meaning d-none d-xl-block">
                  <template v-if="scores.q_1">{{ scores.q_1 }} - {{ voteMeaningArray[voteMeaningArray.length - scores.q_1] }}</template>
                  <template v-else>&nbsp;</template>
                </div>
              </div>
                <span class="input-wrapper star-cb-group no-stars-layout">
                  <input @change="saveJudgingScore()" type="radio" id="content-1_q" v-model="scores.q_1" :value="1" name="q_1">
                  <label class="number-selector" for="content-1_q">1</label>
                  <input @change="saveJudgingScore()" type="radio" id="content-2_q" v-model="scores.q_1" :value="2" name="q_1">
                  <label class="number-selector" for="content-2_q">2</label>
                  <input @change="saveJudgingScore()" type="radio" id="content-3_q" v-model="scores.q_1" :value="3" name="q_1">
                  <label class="number-selector" for="content-3_q">3</label>
                  <input @change="saveJudgingScore()" type="radio" id="content-4_q" v-model="scores.q_1" :value="4" name="q_1">
                  <label class="number-selector" for="content-4_q">4</label>
                  <input @change="saveJudgingScore()" type="radio" id="content-5_q" v-model="scores.q_1" :value="5" name="q_1">
                  <label class="number-selector" for="content-5_q">5</label>
                  <input @change="saveJudgingScore()" type="radio" id="content-6_q" v-model="scores.q_1" :value="6" name="q_1">
                  <label class="number-selector" for="content-6_q">6</label>
                  <input @change="saveJudgingScore()" type="radio" id="content-7_q" v-model="scores.q_1" :value="7" name="q_1">
                  <label class="number-selector" for="content-7_q">7</label>
                </span>
                <div class="font-italic pl-4 pt-2 vote-meaning d-xl-none">
                  <template v-if="scores.q_1">{{ scores.q_1 }} - {{ voteMeaningArray[voteMeaningArray.length - scores.q_1] }}</template>
                  <template v-else>&nbsp;</template>
                </div>
            </fieldset>

            <fieldset class="fieldset-stars-wrapper mt-3 mb-3 d-block d-xl-flex align-items-start justify-content-between">
              <div class="meaning-wrapper">
                <div class="content-label mb-2"><strong>Creativity:</strong> To what extent does the entry embody
                  innovative or distinctive attributes to achieve the entry’s purpose(s)? Give special attention to
                  the concept(s) of the entry that are utilized in an original or unique manner.
                </div>
                <div class="font-italic pl-4 vote-meaning d-none d-xl-block">
                  <template v-if="scores.q_2">{{ scores.q_2 }} - {{ voteMeaningArray[voteMeaningArray.length - scores.q_2] }}</template>
                  <template v-else>&nbsp;</template>
                </div>
              </div>
              <span class="input-wrapper star-cb-group no-stars-layout">
                  <input @change="saveJudgingScore()" type="radio" id="creativity-1_q" v-model="scores.q_2" :value="1" name="q_2">
                  <label class="number-selector" for="creativity-1_q">1</label>
                  <input @change="saveJudgingScore()" type="radio" id="creativity-2_q" v-model="scores.q_2" :value="2" name="q_2">
                  <label class="number-selector" for="creativity-2_q">2</label>
                  <input @change="saveJudgingScore()" type="radio" id="creativity-3_q" v-model="scores.q_2" :value="3" name="q_2">
                  <label class="number-selector" for="creativity-3_q">3</label>
                  <input @change="saveJudgingScore()" type="radio" id="creativity-4_q" v-model="scores.q_2" :value="4" name="q_2">
                  <label class="number-selector" for="creativity-4_q">4</label>
                  <input @change="saveJudgingScore()" type="radio" id="creativity-5_q" v-model="scores.q_2" :value="5" name="q_2">
                  <label class="number-selector" for="creativity-5_q">5</label>
                  <input @change="saveJudgingScore()" type="radio" id="creativity-6_q" v-model="scores.q_2" :value="6" name="q_2">
                  <label class="number-selector" for="creativity-6_q">6</label>
                  <input @change="saveJudgingScore()" type="radio" id="creativity-7_q" v-model="scores.q_2" :value="7" name="q_2">
                  <label class="number-selector" for="creativity-7_q">7</label>
                </span>
              <div class="font-italic pl-4 pt-2 vote-meaning d-xl-none">
                <template v-if="scores.q_2">{{ scores.q_2 }} - {{ voteMeaningArray[voteMeaningArray.length - scores.q_2] }}</template>
                <template v-else>&nbsp;</template>
              </div>
            </fieldset>

            <fieldset class="fieldset-stars-wrapper mt-3 mb-3 d-block d-xl-flex align-items-start justify-content-between">
              <div class="meaning-wrapper">
                <div class="content-label mb-2"><strong>Execution:</strong> To what extent does the production
                  techniques employed enhance the entry’s purpose(s)? Give attention to lighting, sets, direction,
                  audio, camerawork, performance, writing, editing, etc.
                </div>
                <div class="font-italic pl-4 vote-meaning d-none d-xl-block">
                  <template v-if="scores.q_3">{{ scores.q_3 }} - {{ voteMeaningArray[voteMeaningArray.length - scores.q_3] }}</template>
                  <template v-else>&nbsp;</template>
                </div>
              </div>
              <span class="input-wrapper star-cb-group no-stars-layout">
                  <input @change="saveJudgingScore()" type="radio" id="execution-1_q" v-model="scores.q_3" :value="1" name="q_3">
                  <label class="number-selector" for="execution-1_q">1</label>
                  <input @change="saveJudgingScore()" type="radio" id="execution-2_q" v-model="scores.q_3" :value="2" name="q_3">
                  <label class="number-selector" for="execution-2_q">2</label>
                  <input @change="saveJudgingScore()" type="radio" id="execution-3_q" v-model="scores.q_3" :value="3" name="q_3">
                  <label class="number-selector" for="execution-3_q">3</label>
                  <input @change="saveJudgingScore()" type="radio" id="execution-4_q" v-model="scores.q_3" :value="4" name="q_3">
                  <label class="number-selector" for="execution-4_q">4</label>
                  <input @change="saveJudgingScore()" type="radio" id="execution-5_q" v-model="scores.q_3" :value="5" name="q_3">
                  <label class="number-selector" for="execution-5_q">5</label>
                  <input @change="saveJudgingScore()" type="radio" id="execution-6_q" v-model="scores.q_3" :value="6" name="q_3">
                  <label class="number-selector" for="execution-6_q">6</label>
                  <input @change="saveJudgingScore()" type="radio" id="execution-7_q" v-model="scores.q_3" :value="7" name="q_3">
                  <label class="number-selector" for="execution-7_q">7</label>
                </span>
              <div class="font-italic pl-4 pt-2 vote-meaning d-xl-none">
                <template v-if="scores.q_3">{{ scores.q_3 }} - {{ voteMeaningArray[voteMeaningArray.length - scores.q_3] }}</template>
                <template v-else>&nbsp;</template>
              </div>
            </fieldset>

            <div class="d-flex row no-gutters mb-3 justify-content-between">
                <label class="toggle-yes-no-label border-0 pl-0 pr-4">
                    Have you or any member of your family been directly responsible for the development, production,
                    or exhibition of any of the entries that you are judging in this panel?
                </label>
                <div class="input-wrapper toggle-yes-no-input-wrapper">
                    <div class="toggle-js">
                        <span
                            class="yes-toggle"
                            :class="coiToggleItemClass"
                            @click="scores.conflict_of_interest = true; saveJudgingScore()">
                            <checkmark class="svg-18 svg-black"></checkmark> Yes
                        </span>
                        <span class="no-toggle"
                              :class="coiToggleItemClass"
                              @click="scores.conflict_of_interest = false; saveJudgingScore()">
                            <closeicon class="svg-18 svg-black"></closeicon> No
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="judgement-actions d-flex justify-content-between align-items-center pb-5" v-if="isSaving">
            <button type="button" disabled class="btn btn-primary btn-big">Back to list</button>
            <button type="button" disabled class="btn btn-primary btn-big">
                Save scores
            </button>
        </div>
        <div class="judgement-actions d-flex justify-content-between align-items-center pb-5" v-else>
            <a :href="panelUrl" class="btn btn-primary btn-big">Back to list</a>
            <button type="button" class="btn btn-primary btn-big" @click="finalSave">Save scores</button>
        </div>
      </div>
    </div>
</template>

<script>
import checkmark from "./icons/checkmark.vue";
import closeicon from "./icons/close.vue";

export default {
    components: {closeicon, checkmark},
    props: ['action_url', 'entry_id', 'judgements', 'panelUrl'],
    data() {
        return {
            scoreNumbers: [1, 2, 3, 4, 5, 6, 7],
            scores: {
                'q_1': this.judgements.q_1 ? this.judgements.q_1 : '',
                'q_2': this.judgements.q_2 ? this.judgements.q_2 : '',
                'q_3': this.judgements.q_3 ? this.judgements.q_3 : '',
                'conflict_of_interest': this.judgements.conflict_of_interest ?? null,
            },

            saveQueue: [],
            saveProcessing: false,
            voteMeaningArray: [
              'Preeminent',
              'Outstanding',
              'Very Good',
              'Good',
              'Average',
              'Below Average',
              'Poor',
            ]
        }
    },
    computed: {
        isSaving() {
            return this.saveProcessing || this.saveQueue.length > 0;
        },
        coiToggleItemClass() {
            return {
                'active-yes': this.scores.conflict_of_interest === true,
                'active-no': this.scores.conflict_of_interest === false,
            };
        },
    },
    methods: {
        saveJudgingScore() {
            // Queueing the save request to avoid race conditions overriding the scores with previous values
            this.saveQueue.push({...this.scores});
            this.processSaveQueue();
        },

        processSaveQueue() {
            if (this.saveProcessing || this.saveQueue.length === 0) {
                return;
            }

            this.saveProcessing = true;
            const scores = this.saveQueue.shift();

            this.saveScores(scores)
                .then(function () {
                    // Do nothing, auto-save
                }).finally(() => {
                this.saveProcessing = false;
                this.processSaveQueue();
            });
        },

        finalSave() {
            if (this.saveProcessing || this.saveQueue.length > 0) {
                // pending auto-save requests are still in progress
                return;
            }

            this.saveProcessing = true;

            this.saveScores(this.scores)
                .then(() => {
                    window.location.href = this.panelUrl;
                })
                .finally(() => {
                    this.saveProcessing = false;
                });
        },

        saveScores(scores) {
            return window.axios({
                method: 'put',
                url: this.action_url,
                data: scores,
            });
        }
    }
};
</script>